import { Text } from "@medusajs/ui"

export enum PricePreviewType {
  DEFAULT = "DEFAULT",
  DISCOUNT_STRIKE_THROUGH = "DISCOUNT_STRIKE_THROUGH",
}

type PricePreviewProps = {
  type?: PricePreviewType
  originalPrice: number | string
  calculatedPrice?: number | string
}

const PricePreview = ({ type = PricePreviewType.DEFAULT, originalPrice, calculatedPrice }: PricePreviewProps) => {
  return (
    <div className="flex items-center gap-x-2">
      <Text
        className={
          `font-inter ` + (type == PricePreviewType.DISCOUNT_STRIKE_THROUGH ? "text-[#AAAAAA] line-through" : "font-bold text-[#444444]")
        }
      >
        {originalPrice}
      </Text>
      {type == PricePreviewType.DISCOUNT_STRIKE_THROUGH && !!calculatedPrice && (
        <Text className="order-first font-inter font-bold text-[#FF4344]">{calculatedPrice}</Text>
      )}
    </div>
  )
}

export default PricePreview
